import path from 'path';
import dotenv from 'dotenv';
import {ApolloServer} from 'apollo-server-express';
import {applyMiddleware} from 'graphql-middleware';
import {makeExecutableSchema, mergeResolvers, mergeTypeDefs} from 'graphql-tools';
import { GraphQLUpload, graphqlUploadExpress } from 'graphql-upload';
import {resolvers as scalarsResolvers, typeDefs as scalarsTypeDefs} from 'graphql-scalars';
import customTypes from './types';
import select from "./middlewares/select";
import user from "./middlewares/user";
import lang from "./middlewares/lang";
import upload from "./middlewares/upload";
import fieldRequires from "./directives/fieldRequires";
import autoguard from "./directives/autoguard";
import autokey from "./directives/autokey";
import handleInput from "./directives/handleInput";
import input from "./middlewares/input";
import {formatError} from 'apollo-errors';
import createContext from "./tools/createContext";
import {visit} from "graphql";
import transforms from "../server/transforms"
import express from 'express'


dotenv.config({path: path.join(process.cwd(), '.env')});

export default async function (port) {
    let app = require(path.join(process.cwd(), 'api', 'dist'));
    if (app.default) {
        app = await app.default;
    }

    if (!app.typeDefs || !app.resolvers) {
        throw new Error('Incorrect bundle! You must provide an object {typeDefs, resolvers} or a promise that returns this object')
    }

    if (Array.isArray(app.resolvers)) {
        app.resolvers = mergeResolvers(app.resolvers)
    }

    // process custom directives. this process is not unified
    // this is not using "proper" directive visitor to be able process raw ast and non-standart directives
    app = [autokey, autoguard, fieldRequires, handleInput].reduce((acc, cb) => Object.assign(acc, cb(acc)), app)

    let schema = makeExecutableSchema({
        typeDefs: visit(mergeTypeDefs(['scalar Upload', ...scalarsTypeDefs, ...customTypes, app.typeDefs]), transforms),
        resolvers: mergeResolvers([{Upload: GraphQLUpload}, scalarsResolvers, app.resolvers])
    });

    // Build one sdl file have all types you can delete if you not need
    // printSchemaWithDirectives(schema);

    schema = applyMiddleware(schema, lang, user, upload, input(app.inputs), select(app.defaultFieldsMap));

    const serv = express();

    serv.use(graphqlUploadExpress())

    new ApolloServer({
        schema,
        formatError,
        context: createContext,
        playground: true,
        introspection: true,
        uploads: false, // https://www.apollographql.com/docs/apollo-server/data/file-uploads/#uploads-in-node-14-and-later
        // mocks: scalarsMocks,
    }).applyMiddleware({app: serv});

    await serv.listen(port, function(err){
        if (err) console.log("Error in server setup")
        console.log("Server listening on Port", port);
    })
}
